import { PhraseTriggerMessageSource } from "@edgetier/watchtower-types";
import { PhraseSearchFormValues } from "./phrase-search.types";
import { SimilarityValues } from "../../select-similarity/select-similarity.constants";

export const EMPTY_FIELD_GROUP: PhraseSearchFormValues[] = [
    {
        sentence: "",
        source: [PhraseTriggerMessageSource.Customer],
        similarityThreshold: SimilarityValues.EXACT_WORD / 100,
    },
];

export const CLEAR_OPEN_SEARCH_GROUP = {
    search: "",
    searches: undefined,
    textSearchType: undefined,
    similarityThreshold: undefined,
    searchType: undefined,
    parameterGroupId: undefined,
};
export const EXACT_MESSAGE_SOURCES = [PhraseTriggerMessageSource.InteractionDetails, PhraseTriggerMessageSource.System];
